export const version = "transactions/5.0.2";
//# sourceMappingURL=_version.js.map